var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakeOutInvoiced = function SvgTakeOutInvoiced(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM23.9007 12.1211C24.5199 11.44 24.4697 10.3859 23.7886 9.76677C23.1075 9.14759 22.0534 9.19778 21.4342 9.87888L14.1748 17.8643L10.4011 14.7196C9.69399 14.1304 8.64305 14.2259 8.05378 14.933C7.46451 15.6402 7.56004 16.6911 8.26717 17.2804L13.2672 21.447C13.9529 22.0184 14.967 21.9482 15.5674 21.2878L23.9007 12.1211Z",
    fill: "currentColor"
  })));
};
export default SvgTakeOutInvoiced;